import { BonusWheelState } from "src/state/tree/bonusWheel";

export const bonusWheelSelectors = {
  getBonusWheelStatus: (state: BonusWheelState) => state.bonusWheelStatus,
};
